import { Outlet, useLocation } from "react-router-dom";
import Footer from "./footer";
import Header from "./header/Header";
import { LottieAnimation } from '../components/common/LottieAnimation';
import { APPROUTES } from "../assets/constants/constants";
import { useEffect, useState } from "react";

export default function MainLayout() {

  const [tobeExcluded, setTobeExcluded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setTobeExcluded([APPROUTES.termsAndConditions,APPROUTES.privacyPolicy,APPROUTES.cookieSetting].includes(location?.pathname));
  }, [ location?.pathname ])

  return (
    <>
      {
        tobeExcluded ? (
          <></>
        ) : (
          <Header />
        )
      }
      <div className="flex-grow">
        <LottieAnimation />
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
